import axios from 'axios';
import {api} from '../utils/helper';

//****************** Insert donor ******************//
export const insertDonor = async (a) => {
    try{
        const resrep = await axios.post(`${api}/insertdonor`,a, {
            headers: {
              authorization: sessionStorage.getItem('token'),
            },
          },);
          //console.log('insertDonor controller res: ', resrep);
          return resrep;
    }catch (error) {
        //console.log('insertDonor controller error: ', error?.response?.data);
        alert(error?.response?.data?.message);
    }
  
  }


//****************** Update donor ******************//
export const updateDonor = async (a) => {
    try{
        const resrep = await axios.put(`${api}/updatedonor`,a, {
            headers: {
              authorization: sessionStorage.getItem('token'),
            },
          },);
          //console.log('updateDonor controller res: ', resrep);
          return resrep;
    }catch (error) {
        //console.log('updateDonor controller error: ', error?.response?.data);
        alert(error?.response?.data?.message);
    }
  
  }